import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import locationImg from 'images/location_icon-9x11.png';
import dotBtnImg from 'images/dotbtn.png';
import styled from 'styled-components';
import constants from 'utils/constants';
import BottomModal from 'components/presenters/modal/BottomModal';

export default function MyMatchingProfile({profileInfo}) {
  const userInfo = useSelector((state) => {
    return state.userInfo;
  });
  
  //ModalState
  const [visible, setVisible] = useState(false);
  const [dataList, setDataList] = useState([]);

  let profileImgSrc = `${constants['imagePath']}/user_profile_img/${userInfo['profile_img']}`;
  let preferredActivityTxt = null;
  let preferredMbtiTxt = null;
  let preferredLocationTxt = null;
  let preferredInterestList = [];
  if(profileInfo)
  {
    if(profileInfo?.activity_no && profileInfo['activity_no'][0])
    {
      preferredActivityTxt = profileInfo['activity_no'][0]['name'];
    }
    if(profileInfo?.interest_no)
    {
      preferredInterestList = profileInfo['interest_no'];
    }
    if(profileInfo?.mbti_no)
    {
      preferredMbtiTxt = profileInfo['mbti_no']['name'];
    }
    if(profileInfo?.location_no && profileInfo['location_no'][0])
    {
      preferredLocationTxt = profileInfo['location_no'][0]['name'];
    }
  }
  
  let handleOptionClick= () => {
    setVisible(true);
    setDataList([
      {type: 'redirect', text: '수정', path: `/matching/survey`, style:{}}
    ])
  }
  return (
    <ProfileWrapper>
      <ProfileTop>
        <ProfileImgWrapper>
          <ProfileImg src={profileImgSrc}/>
        </ProfileImgWrapper>
        <div>
          <TopInfo>
            <InfoLeft>
              <UserName>{userInfo['name']}</UserName>
              {
                (preferredLocationTxt)
                ?(<>
                  <LocationImgWrapper><LocationImg src={locationImg} /> </LocationImgWrapper>
                  <LocationTxt>{preferredLocationTxt}</LocationTxt>
                  </>)
                :(null)
              }
            </InfoLeft>
            <InfoRight>
              <ProfileOptionBtn onClick={handleOptionClick}>
                <OptionImg src={dotBtnImg} />
              </ProfileOptionBtn>
            </InfoRight>
          </TopInfo>
          <div>
          {
            (preferredMbtiTxt)?(<MbtiItem>#{preferredMbtiTxt}</MbtiItem>):(null)
          }
          {
            preferredInterestList.map((value, index)=>{
              return(<CategoryItem key={`my-profile-category-${value['no']}`}>#{value['name']}</CategoryItem>)
            })
          }
          </div>
        </div>
      </ProfileTop>
      <ProfileMid>
        <PreferredActivityTitle>함께 하고싶은 자기계발</PreferredActivityTitle>
        <PreferredActivity>{preferredActivityTxt}</PreferredActivity>
      </ProfileMid>
      <CreatePostBtn to={`/matching/room/create`}>
        <CreatePostTxt>친구 구하는 글쓰기</CreatePostTxt>
      </CreatePostBtn>

      <BottomModal visible={visible} setVisible={setVisible} dataList={dataList}/>
    </ProfileWrapper>
  );
}
const ProfileWrapper = styled.div`
  background: #FFFFFF;
  box-shadow: 0px 0px 1px #D6D6D6, 0px 3px 8px -1px rgba(214, 214, 214, 0.31);
  border-radius: 10px;
  padding: calc(100vw * (14 / 375)) calc(100vw * (12 / 375));
`;
const ProfileTop = styled.div`
  padding-left: calc(100vw * (60 / 375));
  &::after{
    display: block;
    clear: both;
    content: " ";
  }
  margin-bottom: calc(100vw * (16 / 375));
`
const ProfileImgWrapper = styled.div`
  width : calc(100vw * (49 / 375));
  height : calc(100vw * (49 / 375));
  border-radius: 100%;
  overflow: hidden;
  float: left;
  margin-left: calc(100vw * (-60 / 375));
`;
const ProfileImg = styled.img`
  width : 100%;
  height: 100%;
  object-fit: cover;
`;
const TopInfo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: calc(100vw * (10 / 375));
  width : 100%;
  justify-content: space-between;
`;
const InfoLeft = styled.div`
  display: flex;
  align-items: center;
`;
const InfoRight = styled.div`
`;

const UserName = styled.span`
  display: inline-block;
  font-weight: bold;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (20 / 375));
  color: #121212;
  margin-right: calc(100vw * (5 / 375));
`;
const LocationImgWrapper = styled.span`
  display: inline-block;
  width : calc(100vw * (9 / 375));
  height: calc(100vw * (11 / 375));
`;
const LocationImg = styled.img``;
const LocationTxt = styled.span`
  font-weight: normal;
  font-size: calc(100vw * (10 / 375));
  line-height: calc(100vw * (14 / 375));
  color: #4E4E4E;
`;
const CategoryItem = styled.span`
  display: inline-block;
  padding: calc(100vw * (3 / 375)) calc(100vw * (10 / 375));
  background: #F7F7F7;
  border-radius: calc(100vw * (25 / 375));
  font-size: calc(100vw * (12 / 375));
  line-height: calc(100vw * (17 / 375));
  color: #7F7F7F;
  margin-right: calc(100vw * (5 / 375));
`;

const ProfileOptionBtn = styled.span`
  display: inline-block;
  width : calc(100vw * (24 / 375));
  height : calc(100vw * (24 / 375));
`;
const OptionImg = styled.img`
  height: 100%;
  width: 100%;
  object-fit: contain;
`;

const MbtiItem = styled(CategoryItem)`
  border: 1px solid #F7F7F7;
  background: white;
  margin-bottom: calc(100vw * (10 / 375));
`;

const PreferredActivityTitle = styled.span`
  display: inline-block;
  font-weight: bold;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (20 / 375));
  color: #121212;
  margin-right: calc(100vw * (8 / 375));
`
const PreferredActivity = styled(PreferredActivityTitle)`
  font-weight: normal;
  margin-right: 0;
`;
const ProfileMid = styled.div`
  margin-bottom: calc(100vw * (24 / 375));
`;
const CreatePostBtn = styled(Link)`
  width: 100%;
  display: inline-block;
  background: #EAEAEA;
  border-radius: 8px;
  padding: calc(100vw * (12 / 375)) 0;
  text-align: center;
`;
const CreatePostTxt = styled.span`
  font-weight: bold;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (20 / 375));
  color: #4E4E4E;
`;
